<script>
/* global axios */
// Canal WhatsApp não-oficial (Evolution/WAHA/UazAPI). Cria um inbox Channel::Api
// e vincula uma instância do provedor a ele; a conexão (QR) é feita depois, na
// aba "Conexão" das configurações do inbox.
import { mapGetters } from 'vuex';
import { useVuelidate } from '@vuelidate/core';
import { useAlert } from 'dashboard/composables';
import { required } from '@vuelidate/validators';
import router from '../../../../index';
import PageHeader from '../../SettingsSubPageHeader.vue';
import NextButton from 'dashboard/components-next/button/Button.vue';

export default {
  components: { PageHeader, NextButton },
  props: {
    providerId: {
      type: Number,
      required: true,
    },
  },
  setup() {
    return { v$: useVuelidate() };
  },
  data() {
    return {
      channelName: '',
      creating: false,
      providerName: '',
      providerDescription: '',
    };
  },
  computed: {
    ...mapGetters({
      uiFlags: 'inboxes/getUIFlags',
      accountId: 'getCurrentAccountId',
    }),
    headerTitle() {
      return this.providerName || this.$t('INBOX_MGMT.ADD.WHATSAPP_PROVIDER.TITLE');
    },
    headerContent() {
      return (
        this.providerDescription ||
        this.$t('INBOX_MGMT.ADD.WHATSAPP_PROVIDER.DESC')
      );
    },
  },
  mounted() {
    this.loadProvider();
  },
  validations: {
    channelName: { required },
  },
  methods: {
    async loadProvider() {
      try {
        const { data } = await axios.get(
          `/api/v1/accounts/${this.accountId}/kanban/connections/providers`
        );
        const provider = (data.data || []).find(p => p.id === this.providerId);
        if (provider) {
          this.providerName = provider.name;
          this.providerDescription = provider.description || '';
        }
      } catch (error) {
        // mantém os textos padrão se a busca falhar
      }
    },
    async createChannel() {
      this.v$.$touch();
      if (this.v$.$invalid) return;
      this.creating = true;
      try {
        const inbox = await this.$store.dispatch('inboxes/createChannel', {
          name: this.channelName?.trim(),
          channel: { type: 'api', webhook_url: '' },
        });
        const { data } = await axios.post(
          `/api/v1/accounts/${this.accountId}/kanban/connections/link_inbox`,
          { inbox_id: inbox.id, provider_id: this.providerId }
        );
        // a instância é criada no provedor; se o provedor recusou, avisa mas segue
        // para a aba Conexão (onde dá para reconectar/ver o erro).
        if (data?.error) {
          useAlert(
            `${this.$t('INBOX_MGMT.ADD.WHATSAPP_PROVIDER.PROVIDER_ERROR')}: ${data.error}`
          );
        }
        router.replace({
          name: 'settings_inbox_show',
          params: { inboxId: inbox.id },
        });
      } catch (error) {
        useAlert(
          error?.response?.data?.error ||
            error.message ||
            this.$t('INBOX_MGMT.ADD.WHATSAPP_PROVIDER.ERROR_MESSAGE')
        );
      } finally {
        this.creating = false;
      }
    },
  },
};
</script>

<template>
  <div class="w-full h-full col-span-6 p-6">
    <PageHeader :header-title="headerTitle" :header-content="headerContent" />
    <form
      class="flex flex-col flex-wrap mx-0"
      @submit.prevent="createChannel()"
    >
      <div class="flex-shrink-0 flex-grow-0">
        <label :class="{ error: v$.channelName.$error }">
          {{ $t('INBOX_MGMT.ADD.WHATSAPP_PROVIDER.CHANNEL_NAME.LABEL') }}
          <input
            v-model="channelName"
            type="text"
            :placeholder="
              $t('INBOX_MGMT.ADD.WHATSAPP_PROVIDER.CHANNEL_NAME.PLACEHOLDER')
            "
            @blur="v$.channelName.$touch"
          />
          <span v-if="v$.channelName.$error" class="message">{{
            $t('INBOX_MGMT.ADD.WHATSAPP_PROVIDER.CHANNEL_NAME.ERROR')
          }}</span>
        </label>
      </div>
      <div class="w-full mt-4">
        <NextButton
          :is-loading="creating || uiFlags.isCreating"
          type="submit"
          solid
          blue
          :label="$t('INBOX_MGMT.ADD.WHATSAPP_PROVIDER.SUBMIT_BUTTON')"
        />
      </div>
    </form>
  </div>
</template>
